import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvService } from './env.service';
import { ToastService } from './shared/services/toast/toast.service';

let httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

export interface ScreenSize {
  below600: boolean;
  below768: boolean;
  below992: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private createModeSource = new BehaviorSubject<boolean>(true);
  private readModeSource = new BehaviorSubject<boolean>(true);
  private editModeSource = new BehaviorSubject<boolean>(false);
  private dragModeSource = new BehaviorSubject<boolean>(false);
  private editPermissionSource = new BehaviorSubject<boolean>(false);
  private currentLectureSource = new BehaviorSubject<boolean>(false);
  // Video call drawer logic moved to VideoCallService

  createModeIsSet = false;
  currentLecture$ = this.currentLectureSource.asObservable();

  // ============================  updatedCacheData$ = this.updatedCacheDataSource.asObservable(false)
  //=============================
  private contentSource: BehaviorSubject<any> = new BehaviorSubject({});
  private screenSizeSource: BehaviorSubject<ScreenSize> = new BehaviorSubject({
    below600: false,
    below768: false,
    below992: false,
  });
  content$ = this.contentSource.asObservable();

  fullMenuItemList = [
    {
      value: 'knowledge',
      view: 'Home.Header.CourseButton',
      link: 'knowledge',
    },
    { value: 'path', view: 'Home.Header.Path', link: 'path' },
    { value: 'articles', view: 'Home.Header.BlogButton', link: 'articles' },
    { value: 'notes', view: 'Home.Header.NoteButton', link: 'notes' },
    { value: 'my-space', view: 'Home.Header.Params', link: 'myspace' },
    { value: 'search', view: 'Home.Header.Search', link: 'search' },
    { value: 'groups', view: 'Home.Header.Groups', link: 'groups' },
    {
      value: 'calendar',
      view: 'Home.Header.Calendar',
      link: 'calendar',
    },
    { value: 'questions', view: 'Home.Header.Questions', link: 'questions' },
    { value: 'todos', view: 'Home.Header.MyTasks', link: 'todos' },
    { value: 'logout', view: 'Home.Header.logOut', action: 'logout' },
  ];

  getFullItemList() {
    return this.fullMenuItemList;
  }

  updateContentData(data) {
    this.contentSource.next(data);
  }

  private notesListSource = new BehaviorSubject<any>({});
  notesList$ = this.notesListSource.asObservable();

  sendNotesListNotitification(list) {
    this.notesListSource.next(list);
  }

  addChunkToContent(chunk) {
    let content = this.contentSource.value;
    content.chunks = [...content.chunks, chunk];
    this.contentSource.next(content);
  }

  // =========================================================

  editPermiission$ = this.editPermissionSource.asObservable();
  createMode$ = this.createModeSource.asObservable();
  readMode$ = this.readModeSource.asObservable();
  editMode$ = this.editModeSource.asObservable();
  dragMode$ = this.dragModeSource.asObservable();
  screenSize$ = this.screenSizeSource.asObservable();
  // callDrawer$ now in VideoCallService
  url;

  constructor(
    private http: HttpClient,
    private env: EnvService,
    private translate: TranslateService,
    private toast: ToastService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.url = env.apiUrl;

    this.breakpointObserver
      .observe(['(max-width: 599px)', '(max-width: 768px)', '(max-width: 992px)', '(min-width: 599px)', '(min-width: 768px)', '(min-width: 992px)'])
      .subscribe((result) => {
        if (result.matches) {
          this.screenSizeSource.next({
            below600: result.breakpoints['(max-width: 599px)'],
            below768: result.breakpoints['(max-width: 768px)'],
            below992: result.breakpoints['(max-width: 992px)'],
          });
        }
      });
  }

  appNameIsDemo(): boolean {
    return this.env.appName == 'demo';
  }

  setEditPermission(permitted) {
    this.editPermissionSource.next(permitted);
  }

  setCurrentLecture(lecture) {
    this.currentLectureSource.next(lecture);
  }
  setCreateMode(createMode) {
    this.createModeSource.next(createMode);
  }

  setReadMode(readMode) {
    this.readModeSource.next(readMode);
  }

  setEditMode(editMode) {
    this.editModeSource.next(editMode);
  }

  activateDragMode(dragMode) {
    this.dragModeSource.next(dragMode);
  }

  // setCallDrawer now in VideoCallService

  sortByIndex(array) {
    let result = [];
    for (let i = 0; i < array.length; i++) {
      result.push(array.find((element) => element.index == i));
    }
    return result;
  }

  /**
   * Fetches a course using a "stale-while-revalidate" strategy.
   * - Immediately emits the cached version (if available).
   * - Then, fetches the latest version from the API.
   * - If the API returns new data, it updates the cache and emits the new version.
   */

  /* getBlogPost(id): Observable<any> {
    return this.http.get(this.url + `blog/get?id=${id}`, httpOptions);
  } */

  //=================================

  // getContent(id, location?): Observable<any> {
  //   return this.http.get(this.url + 'contents/' + id + `?location=${location}`, httpOptions)
  // }

  /**
   * Gets data from a collection and returns it as an Observable that
   * automatically updates when the data changes in the database.
   * @param collection The name of the table/collection to query.
   * @param IDs The array of IDs to watch for changes.
   * @returns An Observable that emits the array of matching documents.
   */

  /*   searchAI(
    text,
    modelName,
    compoundOptions,
    includeContext,
    contextDepth?,
    includeOutOfContext?,
    minScore?,
  ): Observable<any> {
    return this.http.get(
      this.url +
        `search/AISearch?query=${text}&model=${modelName}&compoundOptions=${compoundOptions}&minScore=${minScore}&includeContext=${includeContext}&contextDepth=${contextDepth}&includeOutOfContext=${includeOutOfContext}`,
      httpOptions,
    );
  } */

  async copyHTMLToClipBoard(content) {
    try {
      const htmlBlob = new Blob([content], { type: 'text/html' });
      const plainText = content.replace(/<[^>]*>/g, '');
      const plainTextBlob = new Blob([plainText], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({
        'text/html': htmlBlob,
        'text/plain': plainTextBlob,
      });
      await navigator.clipboard.write([clipboardItem]);
      this.toast.snackbar.open(this.translate.instant('Snackbar.CopiedNotification'), 'Ok', { duration: 2000 });
    } catch (err) {
      this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
        duration: 2000,
      });
      console.error(err);
    }
  }

  // Added from app-old.service.ts
  sendSuggestion(data): Observable<any> {
    return this.http.post(this.url + 'messages/suggestion', data, httpOptions);
  }
}
